import { render, staticRenderFns } from "./InviteReceiveModal.vue?vue&type=template&id=b849e8c6&scoped=true"
import script from "./InviteReceiveModal.vue?vue&type=script&lang=js"
export * from "./InviteReceiveModal.vue?vue&type=script&lang=js"
import style0 from "./InviteReceiveModal.vue?vue&type=style&index=0&id=b849e8c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b849e8c6",
  null
  
)

export default component.exports